import { $api } from "services/AxiosInstance";

export class TestEmailService {
  static getAll(isPrefix) {
    return $api.get("/api/admin/testEmail/all", { params: { isPrefix } });
  }

  static getOne(id) {
    return $api.get("/api/admin/testEmail", { params: { id } });
  }

  static create(values) {
    return $api.post("/api/admin/testEmail", values);
  }

  static update(values) {
    return $api.put("/api/admin/testEmail", values);
  }

  static remove(id) {
    return $api.delete("/api/admin/testEmail", { params: { id } });
  }
}
